import { render, staticRenderFns } from "./singleStandingOrder.vue?vue&type=template&id=2d0540ba&scoped=true&"
import script from "./singleStandingOrder.vue?vue&type=script&lang=js&"
export * from "./singleStandingOrder.vue?vue&type=script&lang=js&"
import style0 from "./singleStandingOrder.vue?vue&type=style&index=0&id=2d0540ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0540ba",
  null
  
)

export default component.exports